export const importFromTrelloEn = {
  importFromTrello: 'Import from Trello',
  importFromTrelloUseBrowser: 'Use browser to import from Trello',
  import: 'Import',
  loggedInto: 'You are logged into Trello as',
  selectBoards: 'Select the boards you want to import into YouGile:',
  selectAll: 'Select all boards',
  selectRemove: 'Remove all selection',
  boardsSelected: 'Boards selected:',
  failedToLoadName: 'Failed to load name',
  failedToLoadBoards: 'Failed to load boards',
  failedToLoadBoardsActions: 'Failed to load boards actions',
  errorFromTrello: 'Error from Trello',
  fixThisAndTryAgain: 'Fix this issue and try again',
  warning:
    'Trello integration does not work if you follow your company link, you must be logged into your account from the yougile website to use this feature',
  success: 'Import finished successfully'
}

export const importFromTrelloRu: typeof importFromTrelloEn = {
  importFromTrello: 'Импортировать из Trello',
  importFromTrelloUseBrowser: 'Используйте браузер для импорта из Trello',
  import: 'Импортировать',
  loggedInto: 'Вы вошли в Trello как',
  selectBoards: 'Выберите доски, которые хотите импортировать в YouGile:',
  selectAll: 'Выделить все доски',
  selectRemove: 'Снять все выделения',
  boardsSelected: 'Выбрано досок:',
  failedToLoadName: 'Не удалось загрузить имя',
  failedToLoadBoards: 'Не удалось загрузить доски',
  failedToLoadBoardsActions: 'Не удалось загрузить действия с досок',
  errorFromTrello: 'Ошибка от Trello',
  fixThisAndTryAgain: 'Исправьте эту ошибку и попробуйте еще раз',
  warning:
    'Интеграция с Trello не работает если вы зашли по ссылке вашей компании, необходимо зайти в ваш аккаунт с сайта yougile, чтобы использовать эту функцию',
  success: 'Импорт успешно завершен'
}
